import request from "@/util/request";
import { apiUrl } from "@/api/Url.js";

// 获取图片分类
export function getPictureClassifyList() {
    return request(
        `${apiUrl}/api/v1/charhoo/charhoo-web/picture/classify/list`,
        "get",
    );
}

// 获取图片分页列表
export function getPicturePage(data) {
    return request(
        `${apiUrl}/api/v1/charhoo/charhoo-web/picture/page`,
        "get",
        data
    );
}

// 获取图片详情
export function getPicture(data) {
    return request(
        `${apiUrl}/api/v1/charhoo/charhoo-web/picture/get`,
        "get",
        data
    );
}

// 获取点赞数
export function getPictureLike(data) {
    return request(
        `${apiUrl}/api/v1/charhoo/charhoo-web/picture/like/get`,
        "get",
        data
    );
}

// 点赞
export function pictureLike(data) {
    return request(
        `${apiUrl}/api/v1/charhoo/charhoo-web/picture/like/push`,
        "post",
        data
    );
}